<template>
  <div v-if="affiliate.test" class="alert alert-warning">
    <font-awesome-icon icon="vial" />
    Nedan så visas testdata för detta exempel. Alla eventuella likheter med riktig data är slumpmässig.
  </div>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "TestDataHint",
    computed: {
      ...mapState({
        affiliate: state => state.auth.affiliate,
      })
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/TestData.vue